import HeyJudeUtils from "../Utils/HeyJudeUtils";
import Utils from '../Utils/Utils';
import MessageControl from "./MessageControl";
import SocketModel from '../Model/SocketModel';
import TaskModel from '../Model/TaskModel';
import TaskControl from "./TaskControl";
import TaskListContainer from '../Components/Screen/Task/TaskListContainer';

const notifyIcon = require('../Assets/Img/appIcon.png')

class SocketControl {

  static connectedFromResume = false

  static getInstance(){
    if(SocketControl.instance === undefined){
      SocketControl.instance = new SocketControl();
      SocketControl.instance.setNotify(false);
    }
    
    return SocketControl.instance;
  }

  constructor(){
    this.onSocketMessageReceived = this.onSocketMessageReceived.bind(this);
    this.onSocketStatus = this.onSocketStatus.bind(this);
    this.connect = this.connect.bind(this);
    this.reconnect = this.reconnect.bind(this);
    this.setNotify = this.setNotify.bind(this);
    this.presentNotification = this.presentNotification.bind(this);
    this.requestNotificationPermission = this.requestNotificationPermission.bind(this)
    this.status = undefined;
    this.showNotification = false
    this.hasNotificationPermission = false;
  }

  connect(){
    if(this.status === SocketModel.SOCKET_CONNECTED || SocketControl.connectedFromResume){
      console.log('blocking connection')
      return
    }

    HeyJudeUtils.JudeManager().Auth.bindToChat(this.onSocketMessageReceived)
    HeyJudeUtils.JudeManager().Auth.bindToChatStatus(this.onSocketStatus)

    this.requestNotificationPermission();
  }

  requestNotificationPermission(){
    Notification.requestPermission(function(result){
      if (result === "granted") {
            SocketControl.instance.setNotify(true);
            SocketControl.instance.hasNotificationPermission = true
          }else{
            SocketControl.instance.setNotify(false);
            SocketControl.instance.hasNotificationPermission = false
          }
    })
  }



  reconnect(){
    if(this.status === SocketModel.SOCKET_CONNECTED || SocketControl.connectedFromResume){
      console.log('blocking re connection')
      this.requestNotificationPermission()
      return;
    }
    this.connect();
  }


  onSocketMessageReceived(data){
    console.log("gotten message")
    if(SocketControl.getInstance().showNotification){
      SocketControl.getInstance().presentNotification(data)
    }

    MessageControl.getInstance().receivedMessages(data)
  }

  onSocketStatus(status){
    console.log("SOCKET STATUS :::: >>>>", status)
    SocketModel.getInstance().updateSocketStatus(status);
    this.status = status;

    if(this.status !== SocketModel.SOCKET_DISCONNECTED) {
      SocketControl.connectedFromResume = false
    }
  }

  setNotify(value){
    SocketControl.getInstance().showNotification = value;
  }

  presentNotification(data){
    if(!this.hasNotificationPermission){
      return;
    }
    let taskId = data.taskId;
    var taskData;
    var taskIndex = Utils.getIndexInArrayFromId(taskId,TaskModel.getInstance().getData().openTasks);
    
    let isOpenTask = taskIndex > -1;
    
    if(!isOpenTask){
      taskIndex = Utils.getIndexInArrayFromId(taskId,TaskModel.getInstance().getData().closedTasks);
      taskData = TaskModel.getInstance().getData().closedTasks[taskIndex]
    }else{
      taskData = TaskModel.getInstance().getData().openTasks[taskIndex]
    }

    let title = taskData.title;

    let options = {
      body: 'Task Updated. Click to view',
      icon: notifyIcon,//"icon.jpg",
      dir : "ltr"
    }

    if (("Notification" in window)) {
      var notification = new Notification(title, options);
      notification.onclick = function(e) {
              e.preventDefault();
              window.focus();
              (isOpenTask)
                ? TaskControl.getInstance().setViewTaskType(TaskListContainer.TYPE_OPEN)
                : TaskControl.getInstance().setViewTaskType(TaskListContainer.TYPE_CLOSED);
              MessageControl.getInstance().getTask(taskId);
          // };
      };
    }
  }

}

export default SocketControl